import imageCompression from 'browser-image-compression'

export interface CompressImageOptions {
  /** Целевой максимальный размер файла, МБ */
  maxSizeMB?: number
  /** Ограничение по большей стороне, px */
  maxWidthOrHeight?: number
  /** Сжатие в web worker, чтобы не блокировать UI-поток */
  useWebWorker?: boolean
  /** Начальное качество (0–1) */
  initialQuality?: number
  /** Принудительный формат результата, напр. 'image/jpeg'. По умолчанию сохраняется исходный. */
  fileType?: string
}

const DEFAULT_OPTIONS: CompressImageOptions = {
  maxSizeMB: 1,
  maxWidthOrHeight: 1920,
  useWebWorker: true,
  initialQuality: 0.8,
}

/**
 * Клиентское сжатие изображений перед загрузкой на сервер.
 * Работает только с растровыми image/*; вызывающий код сам решает, что подавать.
 * browser-image-compression сохраняет EXIF-ориентацию и считает в web worker.
 */
export function useImageCompression() {
  async function compressImage(file: File, options: CompressImageOptions = {}): Promise<File> {
    // Возвращает File с сохранённым именем и EXIF-ориентацией исходника.
    return imageCompression(file, { ...DEFAULT_OPTIONS, ...options })
  }

  return { compressImage }
}
